<template>
  <router-view></router-view>
</template>

<script>

/* eslint-disable */
import store from './store'

export default {
  name: 'app',
  data: function(){
		return {
		}
	},
  store
}
</script>
<style lang="css">
  @import '../scss/.custom.scss'
</style>



// WEBPACK FOOTER //
// App.vue?b722f4ba